module.exports = __webpack_public_path__ + "img/filter-type-legs--active.5bbf1e2f.svg";